import {
  Copy,
  Stack,
  Flex,
  Button,
  SvgInfo,
  Popover,
  Square,
} from '@grubhubprod/gh-cookbook-react';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

export const TaxExemptionTooltip: React.FC = () => {
  const { corpid: corpId } = useParams<{ corpid: string }>();

  const [showTooltip, setShowToolip] = useState<boolean>(false);
  const formattedTaxExemptMessage = `Orders paid for with a line of credit are tax-exempt. Review the status of your tax exemption certificates below.`;
  return (
    <Flex data- alignItems="center">
      <Popover
        data-testid="tax-exempt-tooltip"
        position="above"
        removeDefaultPadding
        disable={false}
        showOnHover={false}
        show={showTooltip}
        onClose={() => setShowToolip(false)}
        content={
          <Square width="290px" inset="md">
            <Stack y="md">
              <Copy variant="body">{formattedTaxExemptMessage}</Copy>
            </Stack>
            <Stack y="sm">
              <Button
                variant="secondary"
                buttonSize="small"
                as="a"
                href={`/corporate/enterprise/${corpId}/tax-exemptions`}
              >
                View tax certificates
              </Button>
            </Stack>
          </Square>
        }
      >
        <Flex onClick={() => setShowToolip(true)}>
          <Copy variant="body" color="secondaryText">
            <Flex style={{ cursor: 'pointer' }} alignItems="center">
              <SvgInfo size="16px" />
            </Flex>
          </Copy>
        </Flex>
      </Popover>
    </Flex>
  );
};
